import React from 'react';

// Импортируем модульные стили для секции
import styles from './CatalogSection.module.css';

// Импортируем наш новый переиспользуемый компонент для карточки товара
import ProductCard from '../UI/ProductCard';

// Создаем массив с данными о наших продуктах.
// Источник данных вынесен отдельно от логики отображения - это чистая архитектура.
// Пути к изображениям ведут в папку /public/images/, которую мы создавали ранее.
const productsData = [
  {
    image: '/images/bru-20.jpg',
    title: 'БРУ-20 (Мобильный)',
    specs: [
      { label: 'Производительность', value: '20 м³/час' },
      { label: 'Тип', value: 'Мобильный, на колесном шасси' },
      { label: 'Назначение', value: 'Идеален для небольших объектов' },
    ],
    price: 'от 5 000 000 ₸',
  },
  {
    image: '/images/bru-50.jpg',
    title: 'БРУ-50 (Стационарный)',
    specs: [
      { label: 'Производительность', value: '50 м³/час' },
      { label: 'Тип', value: 'Стационарный, для долгосрочных проектов' },
      { label: 'Назначение', value: 'Для средних строительных проектов' },
    ],
    price: 'от 12 000 000 ₸',
  },
  {
    image: '/images/bru-100.jpg',
    title: 'БРУ-100 (Высокомощный)',
    specs: [
      { label: 'Производительность', value: '100 м³/час' },
      { label: 'Тип', value: 'Стационарный, модульная конструкция' },
      { label: 'Назначение', value: 'Для крупных строек и производства ЖБИ' },
    ],
    price: 'от 25 000 000 ₸',
  },
];

const CatalogSection = () => {
  return (
    <section id="catalog" className={styles.catalogSection}>
      <div className="container">
        <h2 className={styles.sectionTitle}>Каталог оборудования</h2>
        <p className={styles.sectionSubtitle}>
          Выберите модель, которая идеально соответствует масштабам вашего проекта.
        </p>

        {/* Сетка для карточек товаров */}
        <div className={styles.catalogGrid}>
          {/* 
            Используем метод .map() для итерации по массиву productsData.
            Для каждого элемента массива мы рендерим компонент ProductCard,
            передавая ему все необходимые данные через 'props'.
            'product={product}' - это сокращенная запись, эквивалентная
            <ProductCard image={product.image} title={product.title} ... />
            Мы используем spread-оператор '...product' для передачи всех свойств объекта.
          */}
          {productsData.map((product, index) => (
            <ProductCard key={index} {...product} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default CatalogSection;